import "./ProjectsComponent.css";
export default function ProjectsComponent() {
  return (
    <>
      <div className="top-section-projects-page container">
        <div className="title-sec-top-section-projects-page">
          <div className="line-projects-page"></div>
          <p className="title-top-projects-page">مشاريعنا</p>
          <div className="line-projects-page"></div>
        </div>
        <div className="bottom-section-projects-page container">
          <h1 className="head-text-section-2 heading-top-section-projects-page">
          نظرة مستقبلية 

            <span className="your-choose"> وإنجاز متميز </span>
          </h1>
          <p className="desc-section-t desc-top-section-projects-page">
          انغمس في رحلة من الاكتشافات مع مشاريعنا العقارية المتطورة،
          حيث نضمن أعلى معايير الجودة في كل جانب، من البداية إلى أدق التفاصيل النهائية
          </p>
        </div>
      </div>
    </>
  );
}
